import { SimpleForm, Create } from "react-admin";

import { CreateToolbar } from "../../common/CreateToolbar";
import { ArtistSimpleFormContent } from "./components/ArtistSimpleFormContent";

export function ArtistCreate(): JSX.Element {
    return (
        <Create>
            <SimpleForm defaultValues={{ publicationDate: new Date() }} toolbar={<CreateToolbar />}>
                <ArtistSimpleFormContent />
            </SimpleForm>
        </Create>
    );
}
